import { stringToHTML } from '../utils/to-html';
import { $Q, $Qll } from '../utils/query-selector';
import { setQuantity } from '../utils/input-quantity';
import {
  btnAddToCart,
  deleteItem,
  onChangeItemCart,
  recommendedProduct,
} from './cart';
import { barProgressReward } from './bar-reward';
import { validationTC } from './validate-tc';
import { validateUpsellPosition } from './slider-swiper';
import { updateProductDiscount } from './cart-discount';

/**
 * Update cart items section in sidecart
 * @param {string} str - String HTML of section rendeirng
 */
export const updateCartItems = (str) => {
  $Qll('.cartitems-js').forEach((element) => {
    const elementRef = element;
    elementRef.innerHTML = $Q('#cart-items', stringToHTML(str)).outerHTML;
  });

  setQuantity();
  deleteItem();
  onChangeItemCart();
  updateTitle();
  updateProductDiscount(str);
};

/**
 * Hidde or visible the title
 */
const updateTitle = () => {
  const items = $Qll('.cart-items__container').length;
  const title = $Q('.cart-items__title');

  if (items !== 0) {
    title.classList.remove('hidden');
  } else {
    title.classList.add('hidden');
  }
};

/**
 * Update checkout button section in sidecart
 * @param {string} str - String HTML of section rendeirng
 */
export const updateCartbutton = (str) => {
  const inputBarReward = $Q('#data-reward', stringToHTML(str));

  const btnContainer = $Q('.cart-footer', stringToHTML(str));
  const domBtnContainer = $Qll('#container-footer-js');

  barProgressReward(inputBarReward);

  if (btnContainer) {
    domBtnContainer.forEach((element) => {
      const elementRef = element;
      elementRef.innerHTML = btnContainer.outerHTML;
    });
    validationTC();
    recommendedProduct();

    return;
  }

  domBtnContainer.forEach((element) => {
    const elementRef = element;
    elementRef.innerHTML = '';
  });
};

/**
 * Chance all input value only cart page
 *
 * @param {String} id - Variant id item cart
 * @param {String} quantity - Quantity variant by item cart
 */
const updateQuantity = (id, quantity) => {
  $Qll(`.item-cart-js[id="${id}"]`).forEach((element) => {
    const elementRef = element;
    elementRef.value = quantity;
  });
};

/**
 * Update price item for each item in cart items section
 * @param {string} str - String HTML of section rendeirng
 * @param {number} id - Product ID
 */
export const updatePriceItem = (str, id) => {
  const { dataset, innerHTML } = $Q(`#price-${id}`, stringToHTML(str));

  $Qll(`.price-${id}`).forEach((element) => {
    const elementRef = element;
    elementRef.innerHTML = innerHTML;
  });

  updateQuantity(id, dataset.quantity);
};

/**
 * Update total price in cart page
 * @param {string} str - String HTML of section rendeirng
 */
export const updatetotalPrice = (str) => {
  if (!$Q('.cartpage-footer')) return;
  if (!$Q('#total-price', stringToHTML(str))) {
    $Q('.cartpage-footer').style.display = 'none';
    return;
  }

  if ($Q('.cartpage-footer__info--price') != null) {
    $Q('.cartpage-footer__info--price').innerHTML = $Q(
      '#total-price',
      stringToHTML(str)
    ).outerText;

    $Q('.cartpage-footer__info--price').innerHTML = $Q(
      '#subtotal-price',
      stringToHTML(str)
    ).outerText;
  }
};

/**
 * Update upsell section in sidecart
 * @param {string} str - String HTML of section rendeirng
 */
export const updateUpsell = (str) => {
  const activeElemetn = $Q('#cart-upsell-slider', stringToHTML(str)).outerHTML;

  const sliders = $Qll(
    '.cart-upsell-container-product.swiper-slide',
    stringToHTML(str)
  ).length;

  if (sliders !== 0) {
    $Q('#upsell-js').innerHTML = activeElemetn;
    $Q('.cart-upsell-title').classList.remove('hidden');
    $Q('.cart-upsell.upsell-container').classList.remove('hidden');
  } else {
    $Q('.cart-upsell-title').classList.add('hidden');
    $Q('.cart-upsell.upsell-container').classList.add('hidden');
  }

  btnAddToCart('.AddToCartProductDiscount');
  btnAddToCart('.add-product-cart-upsell');
  validateUpsellPosition();
};

/**
 * Update count cart and manage cart empty
 * @param {string} str - String HTML of section rendeirng
 */
export const updateCountCart = (str) => {
  const cartCount = $Q('.cartitems-js', stringToHTML(str));

  if (cartCount) {
    // Update CountCart
    $Qll('.cart-count-bubble span').forEach((item) => {
      item.innerHTML = cartCount.dataset.count;
    });
  }
};
